/* eslint-disable @typescript-eslint/no-explicit-any */
import jwt_decode from "jwt-decode";

import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IDecodedToken } from "@/interfaces/auth.interfaces";
import { IMessage, IMessageInput } from "@/interfaces/message.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class MessageService {
  private baseUrl = "api/v1/message";
  private baseMidiaUrl = "api/v1/midia";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IMessage>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const messages = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return messages;
  }

  async filter(
    filter: IFilter<IMessage>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IMessage>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IMessageInput): Promise<IMessage> {
    const newMessage = await httpRequest.post(this.baseUrl, formData);
    return newMessage;
  }

  async getById(contactId: number): Promise<IMessage> {
    const contact = await httpRequest.get(`${this.baseUrl}/${contactId}`);

    return contact;
  }

  async update(formData: IMessageInput, contactId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${contactId}`, formData);
  }

  async delete(contactId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${contactId}`);
  }

  async createMedia(formData: FormData, accessToken?: string | undefined | null): Promise<any> {
    if (!accessToken) {
      throw new Error("Access token is undefined");
    }

    const decodedToken: IDecodedToken = jwt_decode(accessToken);
    const customerId = decodedToken.CustomerId;

    const response = await httpRequest.post(`${this.baseMidiaUrl}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
        CustomerId: customerId,
      },
    });

    return response;
  }
}

const messageService = new MessageService();
export default messageService;
